import { AreaDetail } from "../../types";
import { parseNumber } from "../../utils/conditions";
import { SectionCard } from "./sectionCard";
import { IconExternal, IconMountain } from "./icons";
import "./aboutCard.css";

export function AboutCard({ detail }: { detail: AreaDetail }) {
    const elevation = parseNumber(detail.elevation);
    const latitude = Number(detail.latitude);
    const longitude = Number(detail.longitude);

    return (
        <SectionCard icon={<IconMountain />} title="About this area">
            {detail.description && <p className="about__description">{detail.description}</p>}
            <dl className="about__facts">
                {elevation !== undefined && (
                    <div className="about__fact">
                        <dt>Elevation</dt>
                        <dd>{Math.round(elevation).toLocaleString("en-US")} ft</dd>
                    </div>
                )}
                <div className="about__fact">
                    <dt>Location</dt>
                    <dd>{latitude.toFixed(4)}, {longitude.toFixed(4)}</dd>
                </div>
            </dl>
            <a
                className="about__map-link"
                href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                Open in Google Maps<IconExternal />
                <span className="cw-sr-only"> (opens in a new tab)</span>
            </a>
        </SectionCard>
    );
}
